export default __webpack_public_path__ + "static/media/Asta.c76e8e33.jpeg";